import { useEffect } from 'react';

export function useTabTitleNotification(unreadCount: number): void {
  useEffect(() => {
    const applyTitle = () => {
      const bare = document.title.replace(/^\(\d+\) /, '');
      if (document.hidden && unreadCount > 0) {
        document.title = `(${unreadCount}) ${bare}`;
      } else {
        document.title = bare;
      }
    };

    applyTitle();
    document.addEventListener('visibilitychange', applyTitle);

    return () => {
      document.removeEventListener('visibilitychange', applyTitle);
      document.title = document.title.replace(/^\(\d+\) /, '');
    };
  }, [unreadCount]);
}
